import { isNull } from "App/utils/helpers";
import { useContext, useState } from "react";
import { useMutation } from "react-query";
import { FormContext } from "../../context/FormContext";
import { getAllFasilitasByKelas } from "../TabFasilitas/DaftarFasilitas/helpers";

const RESET_STATE_FORM_FILTER_JASA = {
  pages: 1,
  limit: 10,
  kelas_id: "",
  asuransi_id: "",
  name: "",
};

const refetchFasilitasByKelas = async (variables) => {
  if (!isNull(variables.kelas_id) && !isNull(variables.asuransi_id)) {
    const response = await getAllFasilitasByKelas(
      {
        kelas_id: variables.kelas_id,
        asuransi_id: variables.asuransi_id,
        name: variables.name,
      },
      variables.pages,
      variables.limit
    );
    return {
      data: response.data,
      meta: response.meta,
    };
  } else {
    return {
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    };
  }
};

export const useDaftarFasilitasByKelas = () => {
  const { formData } = useContext(FormContext);
  const [formFilterFasilitasByKelas, setFormFilterFasilitasByKelas] = useState(
    RESET_STATE_FORM_FILTER_JASA
  );

  const fasilitas = useMutation({
    mutationFn: (variables) => {
      return refetchFasilitasByKelas(variables);
    },
  });

  const rowsFasilitasByKelas = isNull(fasilitas.data)
    ? []
    : fasilitas.data.data;
  const totalDataFasilitasByKelas = isNull(fasilitas.data)
    ? 0
    : fasilitas.data.meta.count;
  const loadingFasilitasByKelas = fasilitas.isLoading;

  const setNewDataFasilitasByKelas = (
    pages = formFilterFasilitasByKelas.pages,
    limit = formFilterFasilitasByKelas.limit,
    formFilter = formFilterFasilitasByKelas
  ) => {
    fasilitas.mutate({
      pages,
      limit,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      name: formFilter.name,
    });
  };

  return {
    loadingFasilitasByKelas,
    setNewDataFasilitasByKelas,
    rowsFasilitasByKelas,
    totalDataFasilitasByKelas,
    formFilterFasilitasByKelas,
    setFormFilterFasilitasByKelas,
  };
};
